export default "/images/fc4ac45279d0593610e6910dcb379d5a.avif";